<template>
	<div>
		<div class="header-item">
			<DropDown :title="title" :mainslug="slug" :content="content"></DropDown>
		</div>

		<router-view :content="allContent" :filtered="content"></router-view>

	</div>

</template>

<script>

import xhrModule from '../modules/xhrModule.js'
import DropDown from '../components/DropDown.vue'

export default {
	name: 'references',
	components: {
		'DropDown': DropDown
	},
	data () {
		return {
			title: 'References',
			allContent: null,
			slug: 'references',
			content: null
		}
	},

	created () {
		this.fetchData()
	},

	methods: {
		fetchData () {
			var url = '/cms/api/entities'
			xhrModule.get(url, this.getContentCompleteHandler.bind(this))
		},

		getContentCompleteHandler (data) {
			var dataLength = data.meta.count
			this.allContent = Object.values(data.data)

			data = data.data
			// select only contentType = settings
			var dataFiltered = []
			var int = 0
			for (var key in data) {
				int++
				if (data[key].settings) {
					if (data[key].settings.contentType) {
						if (data[key].settings.contentType.value === 'references') dataFiltered.push(data[key])
					}
				}
				if (int === dataLength) {
					this.content = dataFiltered
				}
			}
		}
	}
}
</script>
